/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useCallback, useEffect } from "react";

// import tools for editor config
import { EDITOR_JS_TOOLS } from "./tools/tools";

// create editor instance
import { createReactEditorJS } from "react-editor-js";

export default function Editor({ dataJson, setData, setDataJson, dataJsonOnlyView }) {
	const ReactEditorJS = createReactEditorJS();
	const editorInstance = useRef(null);
	const handleInitialize = useCallback((instance) => {
		instance._editorJS.isReady
			.then(() => {
				editorInstance.current = instance; // Store the instance reference
				// If there is initial data, render it into the editor
				// if (dataJson) {
				// 	instance.render(dataJson);
				// }
			})
			.catch((err) => console.error("Editor.js initialization error:", err));
	}, [dataJson]);
	function convertToHTML(data) {
		const blocks = data.blocks;
		let html = "";

		blocks.forEach((block) => {
			switch (block.type) {
				case "header":
					html += `<h${block.data.level}>${block.data.text}</h${block.data.level}>`;
					break;

				case "paragraph":
					html += `<p>${block.data.text}</p>`;
					break;

				case "list":
					const tag = block.data.style === "ordered" ? "ol" : "ul";
					html += `<${tag}>`;
					block.data.items.forEach((item) => {
						html += `<li>${item}</li>`;
					});
					html += `</${tag}>`;
					break;

				case "image":
					html += `<img src="${block.data.file.url}" alt="${block.data.caption || "Image"}" />`;
					if (block.data.caption) {
						html += `<figcaption>${block.data.caption}</figcaption>`;
					}
					break;

				case "simpleImage":
					html += `<img src="${block.data.url}" alt="${block.data.caption || "Simple Image"}" />`;
					if (block.data.caption) {
						html += `<figcaption>${block.data.caption}</figcaption>`;
					}
					break;

				case "quote":
					html += `<blockquote>${block.data.text}</blockquote>`;
					if (block.data.caption) {
						html += `<cite>${block.data.caption}</cite>`;
					}
					break;

				case "table":
					html += "<table>";
					block.data.content.forEach((row) => {
						html += "<tr>";
						row.forEach((cell) => {
							html += `<td>${cell}</td>`;
						});
						html += "</tr>";
					});
					html += "</table>";
					break;

				case "code":
					html += `<pre><code>${block.data.code}</code></pre>`;
					break;

				case "embed":
					html += `
          <div class="embed">
            <iframe src="${block.data.embed}" 
                    width="${block.data.width || "100%"}" 
                    height="${block.data.height || "300"}" 
                    frameborder="0" allowfullscreen>
            </iframe>
            <p>${block.data.caption || ""}</p>
          </div>`;
					break;

				case "linkTool":
					html += `<a href="${block.data.link}" target="_blank" rel="noopener noreferrer">${block.data.meta.title || block.data.link}</a>`;
					break;

				case "warning":
					html += `
          <div class="warning">
            <strong>${block.data.title || "Warning"}:</strong>
            <p>${block.data.message}</p>
          </div>`;
					break;

				case "delimiter":
					html += `<hr />`;
					break;

				case "checklist":
					html += `<ul>`;
					block.data.items.forEach((item) => {
						const checked = item.checked ? "checked" : "";
						html += `<li><input type="checkbox" disabled ${checked} /> ${item.text}</li>`;
					});
					html += `</ul>`;
					break;

				case "inlineCode":
					html += `<code>${block.data.text}</code>`;
					break;

				case "raw":
					html += block.data.html; // Insert raw HTML directly
					break;

				case "marker":
					html += `<mark>${block.data.text}</mark>`;
					break;

				default:
					console.warn(`Unknown block type: ${block.type}`);
			}
		});

		return html;
	}

	const handleSave = useCallback(async () => {
		// retrieve data inserted
		const savedData = await editorInstance.current.save();
		// save data
		// console.log(savedData, "savedData");
		setDataJson(savedData);
		const htmlContent = convertToHTML(savedData);
		// console.log("Generated HTML:", htmlContent);
		setData(htmlContent);

	}, []);


	useEffect(() => {
		if (editorInstance.current) {
			editorInstance.current.clear()
				.then(() => {
					editorInstance.current.render(dataJsonOnlyView);
				})
				.catch((err) => console.error("Error clearing editor instance:", err));
		}
	}, [dataJsonOnlyView]);
	return (
		<div className="editor-container">
			<ReactEditorJS
				onInitialize={handleInitialize}
				tools={EDITOR_JS_TOOLS}
				onChange={handleSave}
				defaultValue={dataJson}
			/>
		</div>
	);
}
